import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { fadeInUpAnimation } from '../../../@fury/animations/fade-in-up.animation';
import { FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ErrorText } from 'src/app/enums/error-text.enum';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { InputType } from 'src/app/enums/input-type.enum';
import { ChangePasswordFormGroupModel } from 'src/app/models/form-group.model';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'fury-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  animations: [fadeInUpAnimation]
})
export class ChangePasswordComponent implements OnInit {
  changePasswordForm!: FormGroup<ChangePasswordFormGroupModel>;
  inputType = InputType.Password;
  visible = false;
  inputTypeConfirm = InputType.Password;
  visibleConfirm = false;
  visibleOld = false;
  inputTypeOld = InputType.Password;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private apiService: ApiService
  ) { 
    this.formInit();
  }
  ngOnInit(): void {
  }
  formInit() {
    this.changePasswordForm = new FormGroup<ChangePasswordFormGroupModel>({
      oldPassword: new FormControl('', Validators.required),
      newPassword: new FormControl('', Validators.required),
      confirmPassword: new FormControl('', Validators.required),
    },{validators: this.comparisonValidator()})
  }

  changePassword() {
    if(this.changePasswordForm.valid) {
      this.apiService.patch('auth/change-password', this.changePasswordForm.value).subscribe((res: any) => {
        if(res.body) {
          this.apiService.alert(res.body.message, ErrorType.Success);
          this.changePasswordForm.reset();
        }
      },
      err => {
        this.apiService.alert(err?.message, ErrorType.Error);
      });
    } else {
      this.changePasswordForm.markAllAsTouched();
    }
    
  }

  comparisonValidator(): any {
    return (group: FormGroup): any => {
      const password = group.controls['newPassword'];
      const confirmPassword = group.controls['confirmPassword'];
      if (confirmPassword.errors && confirmPassword.errors['valuesDoNotMatch'])
        return;
      password.value !== confirmPassword.value ? confirmPassword.setErrors({ valuesDoNotMatch: true }) : confirmPassword.setErrors(null);
    };
  }

  toggleVisibility() {
    if (this.visible) {
      this.inputType = InputType.Password;
      this.visible = false;
      this.changeDetectorRef.markForCheck();
    } else {
      this.inputType = InputType.Text;
      this.visible = true;
      this.changeDetectorRef.markForCheck();
    }
  }

  toggleVisibilityConfirm() {
    if (this.visibleConfirm) {
      this.inputTypeConfirm = InputType.Password;
      this.visibleConfirm = false;
      this.changeDetectorRef.markForCheck();
    } else {
      this.inputTypeConfirm = InputType.Text;
      this.visibleConfirm = true;
      this.changeDetectorRef.markForCheck();
    }
  }

  toggleVisibilityOld() {
    if (this.visibleOld) {
      this.inputTypeOld = InputType.Password;
      this.visibleOld = false;
      this.changeDetectorRef.markForCheck();
    } else {
      this.inputTypeOld = InputType.Text;
      this.visibleOld = true;
      this.changeDetectorRef.markForCheck();
    }
  }


}
